<div class="table-container">
    <app-table [data]="tools"
               [treeMode]="tree"
               [config]="tableConfig"
               [isLoading]="isLoading"
               [hasPagination]="false"
               [filtersToggle]="false"
               [showFilters]="showFilters"
               [groupableColumns]="groupableColumns"
               (pageChange)="onPageChange($event)"
               (sortChange)="onSortChange($event)"
               (filterChange)="onFilterChange($event)">
        <app-table-column header="{{'atom.tool-requests-facilities.process.table.columns.name' | translate}}"
                          [showTree]="true"
                          [filter]="filter"
                          [sortable]="false"
                          filterPlaceholder="{{'atom.tool-requests-facilities.process.table.filters.byName' | translate}}"
                          field="name">
        </app-table-column>
        <app-table-column header="{{'atom.tool-requests-facilities.process.table.columns.uid' | translate}}"
                          [filter]="filter"
                          [sortable]="false"
                          filterPlaceholder="{{'atom.tool-requests-facilities.process.table.filters.byUid' | translate}}"
                          field="toolUidAndSetId">
        </app-table-column>
        <app-table-column header="{{'atom.tool-requests-facilities.process.table.columns.status' | translate}}"
                          [sortable]="false"
                          field="status">
        </app-table-column>
        <app-table-column header="{{'atom.tool-requests-facilities.process.table.columns.stance' | translate}}"
                          [sortable]="false"
                          field="stance">
        </app-table-column>
    </app-table>
</div>


